<template>
  <div class="single-obituary-comment__actions">
    <like-comment-action v-if="!showEditButtons" :comment="comment" />

    <button
      v-if="showEditButtons"
      class="btn icon small-icon single-obituary-comment__actions-edit"
      @click.prevent="openEditCommentModal"
    >
      <svg class="icon"><use href="#pen" /></svg>
      <span v-text="texts.edit" />
    </button>

    <threaded-comments-button :parent="comment" />

    <button class="btn icon small-icon" @click.prevent="share">
      <svg class="icon"><use href="#share" /></svg>
      <span v-text="texts.share" />
    </button>

    <more-comment-actions :comment="comment" />
  </div>
</template>

<script>
import Share from 'Modules/Share';
import LikeCommentAction from './LikeCommentAction.vue';
import MoreCommentActions from './MoreCommentActions.vue';
import ThreadedCommentsButton from './ThreadedComments/Button.vue';
import { mapActions, mapMutations } from 'vuex';

export default {
  name: 'SingleCommentActions',

  components: {
    LikeCommentAction,
    MoreCommentActions,
    ThreadedCommentsButton,
  },

  props: {
    toggleModal: {
      type: Function,
      required: true,
    },
    showEditButtons: {
      type: Boolean,
      required: true,
    },
    comment: {
      type: Object,
      required: true,
    },
    deceasedName: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      texts: lavendlaObituary.common,
    };
  },

  methods: {
    ...mapMutations('threadedComments', ['setParent']),
    ...mapActions({
      toggleThreadedComments: 'threadedComments/toggleModal',
    }),

    share() {
      const share = new Share(
        this.comment.url,
        this.openShareCommentModal,
        `${this.texts.inMemoryOf} ${this.deceasedName}`
      );

      share.init();
    },

    writeComment() {
      this.setParent(this.comment);
      this.toggleThreadedComments('create');
    },

    openShareCommentModal() {
      this.toggleModal('share');
    },

    openEditCommentModal() {
      this.toggleModal('edit');
    },
  },
};
</script>
